"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCookie = exports.getCookie = exports.deleteCookie = void 0;
var _entries2 = _interopRequireDefault(require("lodash/entries"));
var console = _interopRequireWildcard(require("../console"));
var dom = _interopRequireWildcard(require("../dom"));
var _excluded = ["expires"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var getCookie = exports.getCookie = function getCookie(name) {
  if (!dom.isBrowser()) {
    console.consoleWarn('Unable to use getCookie on server side');
    return undefined;
  }
  var matches = document.cookie.match(new RegExp("(?:^|; )".concat(name.replace(/([.$?*|{}\\[\]\\/+^])/g, '\\$1'), "=([^;]*)")));
  return matches ? decodeURIComponent(matches[1]) : undefined;
};

/**
 * @param name
 * @param value
 * @param expires, time in milliseconds, if value equal undefined or 0 it will as session cookie
 * @param otherOptions, (path, domain, secure, httpOnly)
 */
var setCookie = exports.setCookie = function setCookie(name, value, _ref) {
  var expires = _ref.expires,
    otherOptions = _objectWithoutProperties(_ref, _excluded);
  if (!dom.isBrowser()) {
    console.consoleWarn('Unable to use `setCookie` on server side');
    return;
  }
  var options = otherOptions;
  if (typeof expires === 'number' && expires !== 0) {
    var date = new Date();
    date.setTime(date.getTime() + expires);
    options.expires = date.toUTCString();
  }
  var updatedCookie = "".concat(name, "=").concat(encodeURIComponent(value));
  (0, _entries2["default"])(options).forEach(function (option) {
    updatedCookie += "; ".concat(option[0]);
    if (option[1] !== true) {
      updatedCookie += "=".concat(option[1]);
    }
  });
  document.cookie = updatedCookie;
};
var deleteCookie = exports.deleteCookie = function deleteCookie(name, options) {
  if (!dom.isBrowser()) {
    console.consoleWarn('Unable to use deleteCookie on server side');
    return;
  }
  setCookie(name, '', _objectSpread(_objectSpread({}, options), {}, {
    expires: -1
  }));
};